import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import ApproversModal from 'component/usageConsumptionApprovers/ApproversModal'

const REMOVE = 'MISSION_REMOVE'
let modalType = REMOVE

class UsageConsumptionApproversTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      menuMissionsSelected: [],
      menuMissionsSelectedIndex: [],
      lastApproversSelected: null,
      approversModal: false,
      totalSelected: 0,
    }
  }

  openRemoveModal = () => {
    modalType = REMOVE
    this.toggleApproversModal()
  }

  toggleApproversModal = () => {
    this.setState({ approversModal: !this.state.approversModal })
  }

  renderApproversModal = () => {
    const { approversModal } = this.state
    const { translate } = this.props

    if (!approversModal) {
      return
    }

    let props = {}
    if (modalType === REMOVE) {
      props = {
        modalType: REMOVE,
        translate,
        closeModal: this.toggleApproversModal,
        onSubmit: this.handleDelete,
      }
    }

    return <ApproversModal {...props} />
  }

  handleDelete = () => {
    const { delMenuMission } = this.props
    const { lastApproversSelected } = this.state

    delMenuMission(lastApproversSelected)
    this.toggleApproversModal()
  }

  handleRemove = (value) => {
    this.setState({ lastApproversSelected: value })
    this.openViewModal()
  }

  openViewModal = () => {
    modalType = REMOVE
    this.toogleApproversModal()
  }

  toogleApproversModal = () => {
    this.setState({ approversModal: !this.state.approversModal })
  }

  renderRows = (menuMission, index) => (
    <tr key={index}>
      <td className='align-left overflow-hidden-column'>
        {menuMission.dsMission}
      </td>
      <td className='align-right'>
        <a
          className='margin-right'
          id={`view-mission-${index}`}
          role='button'
          onClick={() => this.handleRemove(menuMission)}
        >
          <i className='glyph glyph-trash-can icon-size' />
        </a>
      </td>
    </tr>
  )

  render() {
    
    const { menuMissions, translate, renderButtons } = this.props

    return (
      <div className='ApproversTable'>
        {renderButtons && (
          <Row className='margin-top-double margin-bottom width-100'>
            <Col xs={12} md={6} className='margin-bottom'>
              <div className='display-inline'>
                <span>
                  {`${this.state.totalSelected} ${translate(
                    'usage-consumption-approvers.added-mission-list'
                  )}  |  `}
                </span>

                <span>{'  |  '}</span>
              </div>
            </Col>

            <Col xs={12} md={3} className='float-right'>
              <button
                role='button'
                onClick={this.openRemoveModal}
                className='button button-danger button-full align-center'
              >
                {translate('option.removeSelected')}
              </button>
            </Col>
          </Row>
        )}

        <table className='table table-zebra margin-top-double table-layout-fixed'>
          <thead>
            <tr>
              <th className='align-left overflow-hidden-column'>
                {translate('usage-consumption-approvers.mission')}
              </th>
            </tr>
          </thead>
          <tbody>{(menuMissions || []).map(this.renderRows)}</tbody>
        </table>

        {this.renderApproversModal()}
      </div>
    )
  }
}

UsageConsumptionApproversTable.propTypes = {
  menuMissions: PropTypes.array.isRequired,
  translate: PropTypes.func.isRequired,
  delMenuMission: PropTypes.func.isRequired,
  renderButtons: PropTypes.bool.isRequired,
  setRenderButtons: PropTypes.func.isRequired,
}

export default UsageConsumptionApproversTable
